'use client';

import { usePathname } from 'next/navigation';
import type { ComponentProps } from 'react';

import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useCheckPartnerWebview } from '@/hooks/useCheckPartnerWebview';

import { CustomLink } from './CustomLink';

type PartnerHomeLinkProps = Omit<ComponentProps<typeof CustomLink>, 'href'>;

//* 카뱅·토스 웹뷰와 기부 하위 화면의 에러·404 CTA는 기부홈으로 보낸다 — 파트너 셸은 www로 보내면 막다른 길이 된다
export const PartnerHomeLink = (props: PartnerHomeLinkProps) => {
  const isPartnerWebview = useCheckPartnerWebview();
  const pathname = usePathname() ?? '';
  const donationHomePathname = DONATION_ROUTES.HOME.pathname;
  const isDonationPage =
    pathname === donationHomePathname ||
    pathname.startsWith(`${donationHomePathname}/`);

  return (
    <CustomLink
      href={
        isPartnerWebview || isDonationPage
          ? DONATION_ROUTES.HOME.pathname
          : ROUTES.HOME.pathname
      }
      {...props}
    />
  );
};
